import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const StatusCard = ({ 
  title, 
  icon: Icon, 
  iconColor, 
  children, 
  className = "" 
}) => {
  return (
    <Card className={`shadow-lg ${className}`}>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Icon className={`w-6 h-6 text-${iconColor}-600`} />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {children}
      </CardContent>
    </Card>
  );
};

export default StatusCard;
